module.exports = __webpack_public_path__ + "img/logo-1.4fe87f9f.png";